import React, { PureComponent, ReactElement } from 'react';
import { Field } from 'react-final-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import { RenderDropdown, validators } from 'forms';
import { WorksheetType } from 'services/worksheet/types';
import { ApplicatorOptions } from './types';
import { makeSelectOptions } from './selectors';

const { isRequired } = validators;

export interface OwnProps {
    eventStartDate: string;
    worksheetType: WorksheetType;
}

export interface ConnectedProps {
    options: ApplicatorOptions;
}

export type Props = OwnProps & ConnectedProps;

export class ApplicatorFieldComponent extends PureComponent<Props> {
    render(): ReactElement {
        const { options } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name="operatorPersonId"
                label="Applicator"
                placeholder="Select an applicator"
                validate={isRequired}
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                options={options}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: makeSelectOptions()
});

export default connect(mapStateToProps)(ApplicatorFieldComponent);
